import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthenticationService, DataService, ToastrService } from '../../_services/index';
import { NgxSpinnerService } from 'ngx-spinner';
import { LandingPageService } from '../../_services/landingpage.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [ToastrService, LandingPageService]
})
export class LoginComponent implements OnInit {
    model: any = {};
    inpArray: Array<any> = [];
    loading = false;
    returnUrl: string;
    errorMessage: any;
    usersForm: FormGroup;
    email: FormControl;
    cemail: FormControl;
    password: FormControl;
    cpassword: FormControl;
    _BTNcolor: string;
    redemptionParams: any;
    logoutActionResult: any;
    isLoginFailed: boolean = false;
    loginFailureMessage: string;
    redemptionParamsStringified: string;

    constructor(private activatedRoute: ActivatedRoute,
        private router: Router,
        private route: ActivatedRoute,
        private _dataService: DataService,
        private authenticationService: AuthenticationService,
        private _toastrService: ToastrService,
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private _landingPageService: LandingPageService) {
    }

    ngOnInit() {
        this._BTNcolor = '#333';
        this.createFormControls();
        this.createForm();
        this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        this.route.queryParams.subscribe(async (params) => {
            this.redemptionParams = JSON.parse((params['redemptionParams'] || '{}'));
            this.redemptionParamsStringified = ((params['redemptionParams'] || ''));

            this.logoutActionResult = await this.authenticationService.logout(this.redemptionParams);
            if (this.logoutActionResult.status == 'success')
                this.router.navigate(['landing-page']);
        });

        (<any>window).gtag('config', environment.gaId, { 'page_path': `/login` });
    }

    login() {
        localStorage.clear();
        if (this.authenticationService.isLoggedIn()) {
            this.router.navigate(['home']);
            return;
        } else {
            this.loading = true;
            this.authenticationService.login(this.model.username, this.model.lpassword)
                .subscribe(
                    (data: { data: any, response: string, response_message: Array<any> }) => {
                        if (data.response === 'success') {
                            if ((this.redemptionParams || {}).keyId > 0 && (this.redemptionParams || {}).keyStatus == 'available') {
                                this.spinner.show();
                                this._landingPageService.setParams(this.redemptionParams);
                            }
                            else
                                this.router.navigate(['home']);

                            this.loading = false;

                            (<any>window).gtag('event', 'Click', {
                                'event_category': 'Button Clicked',
                                'event_label': `Login Button by User ${this.model.username}`
                            });
                        }
                    },
                    (error) => {
                        this.isLoginFailed = true;
                        this.loginFailureMessage = (error.error.response_message || error.status_text);
                        // this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                        this.loading = false;
                        // this.router.navigate(['landing-page']);
                    });
        }
    }

    createFormControls() {
        this.email = new FormControl('', {
            validators: [Validators.required,
            Validators.pattern("[^ @]*@[^ @]*")],
            // updateOn: 'submit'
            updateOn: 'change'
        });
        this.cemail = new FormControl('', {
            validators: [Validators.compose(
                [Validators.required, this.validateAreEqual.bind(this, this.email)]
            )],
            // updateOn: 'submit'
            updateOn: 'change'
        });
        this.password = new FormControl('', {
            validators: Validators.required,
            // updateOn: 'submit'
            updateOn: 'change'
        });
        this.cpassword = new FormControl('', {
            validators: [Validators.compose(
                [Validators.required, this.validateAreEqual.bind(this, this.password)]
            )],
            // updateOn: 'submit'
            updateOn: 'change'
        });
    }

    private validateAreEqual(fieldControl: FormControl, fieldControl1: FormControl) {
        if (fieldControl) {
            return fieldControl.value === fieldControl1.value ? null : {
                NotEqual: true
            };
        }

    }

    private createForm() {
        this.usersForm = new FormGroup({
            email: this.email,
            cemail: this.cemail,
            password: this.password,
            cpassword: this.cpassword
        });
    }

    onSubmit() {
        const formData = this.usersForm["controls"];
        formData['email'].markAsTouched();
        formData['cemail'].markAsTouched();
        formData['password'].markAsTouched();
        formData['cpassword'].markAsTouched();
    }

    changeColor(email, cemail, pass, cpass) {
        if (email.length > 1 && pass.length > 1) {
            if ((email === cemail) && (pass === cpass)) {
                this._BTNcolor = '#28a745';
            } else {
                this._BTNcolor = '#333';
            }
        }
    }

    createAccount(form) {
        const formData = form.value;
        if (!this.usersForm.valid) {
            this.onSubmit();
            return;
        }
        this.loading = true;
        const url = '/api/createAccount';
        const body = {
            email: formData.email,
            password: formData.password,
            cpassword: formData.cpassword
        };
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        if (data.data.insertId) {
                            localStorage.setItem('newuserinsertId', data.data.insertId);
                            this.router.navigate(['new-user']);
                        }

                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `Create Account Button by User ID ${data.data.insertId} (${formData.email})`
                        });
                    }
                },
                (error) => {
                    // this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this.loading = false;
                    this.router.navigate(['login']);
                });
    }
}



// WEBPACK FOOTER //
// ./public/app/modules/login/login.component.ts